export const ONE_SECOND = 1000;
export const ONE_SECOND_250MS = 1250;
export const TWO_SECONDS = 2;
export const THREE_SECONDS = 3;
export const THREE_MINUTES = 180;
export const TEN_MINUTES_IN_SECONDS = 600;
export const GENERAL_AUDIO_DELAY = 700;
export const TRIGGER_CLICK_DURATION = 500;
export const FLUENCY_READING_REMINDER_DELAY = 3;
export const PREVENT_DOUBLE_TAP_DELAY = 500;
export const FLUENCY_MIN_SEGMENT_READING_SECS = {
    '01': 2,
    '02': 2,
    '03': 2,
    '04': 2,
    '05': 2,
    '06': 2,
};
export const FLUENCY_DOWN_BUTTON_AUTO_ADVANCE = {
    '01': 55,
    '02': 55,
    '03': 55,
    '04': 55,
    '05': 45,
    '06': 45,
};
// HACK: use number instead of Object
// Object type was used to easily substitute this value in tests,
// so after migration to number, update corresponding testHook to use MockTimer
export const FLUENCY_QUESTION_AUTO_ADVANCE = {
    FOR_ALL_GRADES: 120,
};
// HACK: use number instead of Object
// Object type was used to easily substitute this value in tests,
// so after migration to number, update corresponding testHook to use MockTimer
export const DAZE_DISCONTINUE_RULE = {
    TIME: THREE_MINUTES,
};
export const UNITS = {
    SECOND_TENTHS: 'secondTenths',
    SECONDS: 'seconds',
    MINUTES: 'minutes',
    HOURS: 'hours',
    DAYS: 'days',
};

export const isValidLanternTimerUnit = unit => {
    let result = false;

    Object.keys(UNITS).forEach(key => {
        result = result || UNITS[key] === unit;
    });

    return result;
};

export let WAITING_SOAPBOX_TIMEOUT_MS = 120000;
export let WAITING_SOAPBOX_RETRY_DELAY_MS = 35000;
export let WAITING_SOAPBOX_RETRY_DELAY_THRESHOLD_MS = 5000;

export const DISCONTINUE_TIMER = 'discontinueTimer';
